import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';

import { IconComponent } from '@ui-kit/components/base/icon/icon.component';

@Component({
  selector: 'app-errors-401',
  template: `
    <div class="flex h-screen w-screen items-center justify-center text-center tracking-tight">
      <div class="flex flex-col items-center gap-6">
        <div
          class="flex shrink items-center justify-center rounded-md border border-[var(--color-border-default)] p-1 shadow">
          <app-icon icon="tabler-clock" iconClass="!size-8 text-primary" />
        </div>
        <span class="text-xs text-primary">Błąd 401</span>
        <span class="text-2xl font-semibold text-section-title">Sesja wygasła</span>
        <span class="font-semibold text-caret">Twoja sesja wygasła. Zaloguj się ponownie, aby kontynuować.</span>
        <button class="font-bold" mat-flat-button [routerLink]="['/auth/sign-in']">
          <span class="tracking-tight">Zaloguj się ponownie</span>
        </button>
      </div>
    </div>
  `,
  imports: [IconComponent, MatButton, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Error401Component {}
